import CodonationCalculator from './CodonationCalculator'

export default CodonationCalculator
